<template>
  <div class="flex flex-row flex-wrap sm:flex-nowrap gap-4">
    <DynamicInputComponent
      class="flex-basis-0 flex-grow"
      v-for="field in fields"
      :key="'composite-field-' + field.key"
      :field="field"
      :form="form"
      :modelValue="form?.[field.key]"
      :disabled="disabled"
      @update:modelValue="debounceInputHandlers[field.key]"
      :debounce="debounce"
    />
  </div>
</template>

<script setup>
import { useDebounceFn } from "@vueuse/core";
import DynamicInputComponent from "@/Tailwind/Components/Settings/DynamicInputComponent.vue";

const props = defineProps({
  fields: Array,
  form: Object,
  disabled: Boolean,
  debounce: Boolean,
});

const debounceInputHandlers = props.fields.reduce((acc, field) => {
  acc[field.key] = useDebounceFn(
    (field, e) => {
      emit("composite-input", field, e);
    },
    props.debounce ? 750 : 0
  );

  return acc;
}, {});

const emit = defineEmits(["composite-input"]);
</script>
